import React from "react"

import { EmailVerificationPageView } from "./EmailVerificationPageView"
import { useEmailVerificationPageViewModel } from "./hooks/useEmailVerificationPageViewModel"

export interface EmailVerificationPageModel {
  navigateToHomepage: () => void
}

export const EmailVerificationPage = React.memo(
  (props: EmailVerificationPageModel) => {
    return (
      <EmailVerificationPageView
        {...useEmailVerificationPageViewModel(props)}
      />
    )
  }
)
